export { default as NConfigProvider, configProviderProps } from './src/ConfigProvider';
export * from './src/interface';
